import { ChevronRight, Home } from 'lucide-react';
import { useWorkflowNavigation } from './WorkflowNavigationContext';
import { cn } from '@/lib/utils';

export function WorkflowBreadcrumb() {
    const { workflowStack, currentWorkflow, navigateToStack, isNested } = useWorkflowNavigation();

    if (!isNested) return null;

    const allItems = [...workflowStack, currentWorkflow].filter(Boolean);

    return (
        <nav className="flex items-center gap-1 border-b border-slate-200 bg-slate-100 px-4 py-2 text-sm">
            <Home className="h-4 w-4 text-slate-400" />
            {allItems.map((item, index) => {
                const isCurrent = index === allItems.length - 1;

                return (
                    <div key={item!.id} className="flex items-center gap-1">
                        <ChevronRight className="h-4 w-4 text-slate-300" />
                        <button
                            onClick={() => !isCurrent && navigateToStack(index)}
                            disabled={isCurrent}
                            className={cn(
                                'rounded px-2 py-1 transition-colors',
                                isCurrent
                                    ? 'cursor-default font-medium text-slate-900'
                                    : 'text-slate-600 hover:bg-slate-200 hover:text-slate-900'
                            )}
                        >
                            {item!.name}
                        </button>
                    </div>
                );
            })}
        </nav>
    );
}

